export function parseBarcode(barcode) {
    const eanRegex = /^\d{8}$|^\d{13}$/;
    if (eanRegex.test(barcode)) {
        return { type: "EAN", EAN: barcode };
    }

    const cleanedBarcode = barcode.replace(/[()\s]/g, "");

    if (!cleanedBarcode.includes("01")) {
        return { type: "UNKNOWN", EAN: barcode };
    }

    const aiLengths = {
        "01": 14,
        "17": 6,
        "11": 6,
        "10": null,
        "21": null
    };

    let index = 0;
    const parsedData = {};

    while (index < cleanedBarcode.length) {
        const aiCandidate = cleanedBarcode.substring(index, Math.min(index + 3, cleanedBarcode.length));
        const ai = aiLengths.hasOwnProperty(aiCandidate.slice(0, 2))
            ? aiCandidate.slice(0, 2)
            : aiLengths.hasOwnProperty(aiCandidate)
                ? aiCandidate
                : null;

        if (!ai) {
            return { type: "UNKNOWN", EAN: barcode };
        }

        index += ai.length;
        const length = aiLengths[ai];

        let value;
        if (length !== null) {
            if (index + length > cleanedBarcode.length) {
                return { type: "UNKNOWN", EAN: barcode };
            }
            value = cleanedBarcode.substring(index, index + length);
            index += length;
        } else {
            let nextAIIndex = cleanedBarcode.length;
            for (let i = index; i < cleanedBarcode.length; i++) {
                if (Object.keys(aiLengths).some(aiKey => cleanedBarcode.startsWith(aiKey, i))) {
                    nextAIIndex = i;
                    break;
                }
            }
            value = cleanedBarcode.substring(index, nextAIIndex);
            index = nextAIIndex;
        }

        switch (ai) {
            case "01":
                parsedData["EAN"] = value;
                parsedData["CODE_WITHOUT_ZERO"] = value.replace(/^0/, '');
                break;
            case "17":
                parsedData["expirationDate"] = value;
                break;
            case "11":
                parsedData["productionDate"] = value;
                break;
            case "10":
                parsedData["batch"] = value;
                break;
            case "21":
                parsedData["serialNumber"] = value;
                break;
            default:
                parsedData[`AI_${ai}`] = value;
                break;
        }
    }

    if (Object.keys(parsedData).length > 0) {
        parsedData["type"] = "UDI";
        parsedData["originalCode"] = barcode;
        return parsedData;
    } else {
        return { type: "UNKNOWN", EAN: barcode };
    }
}